import { render, staticRenderFns } from "./news-layout.vue?vue&type=template&id=6021f1d1&scoped=true&"
import script from "./news-layout.vue?vue&type=script&lang=js&"
export * from "./news-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021f1d1",
  null
  
)

export default component.exports